import {useState, useMemo} from 'react'
import PageShell from '../layouts/PageShell'
import {FeatureCheckmarkNoBg} from '../assets/FeatureCheckmarkNoBg.jsx'
import Navbar from '../features/Navbar'
import PromoBanner from '../features/PromoBanner'
import PricingGrid from '../features/pricing/PricingGrid.jsx'
import {pricingPlans} from '../features/pricing/data/pricingPlans.js'
import PlanFeatures from '../features/pricing/PricingFeature.jsx'

const Pricing = () => {
  const [billing, setBilling] = useState('annual')

  const plans = useMemo(() => {
    return pricingPlans[billing]
  }, [billing])
  

    const PricingToggle = ({ billing, setBilling }) => {
        return (
            <div className="inline-flex items-center p-[4px] rounded-full border border-black/10 bg-white shadow-soft">
            <button
                onClick={() => setBilling('monthly')}
                className={`
                h-[36px]
                px-4
                rounded-full
                text-[14px]
                font-semibold
                transition-all
                duration-300

                ${
                    billing === 'monthly'
                    ? 'bg-brand-green text-white'
                    : 'text-black/55 hover:text-brand-dark'
                }
                `}
            >
                Monthly
            </button>

            <button
                onClick={() => setBilling('annual')}
                className={`
                h-[36px]
                px-4
                rounded-full
                text-[14px]
                font-semibold
                transition-all
                duration-300

                ${
                    billing === 'annual'
                    ? 'bg-brand-green text-white'
                    : 'text-black/55 hover:text-brand-dark'
                }
                `}
            >
                Annual (Save Up To 50%)
            </button>
            </div>
        )
    }

  return (
    <PageShell>
      <Navbar />
      <PromoBanner />

      <section className="bg-brand-pageFill min-h-screen pt-[120px] pb-[120px]">
        <div className="flex flex-col text-center">
          <h1 className="text-[56px] leading-none tracking-[-3px] font-black text-brand-dark">
            Our Pricing Plans
          </h1>

          <p className="mt-5 mb-4 text-[24px] font-bold text-brand-dark">
            Make every deal a calculated, confident decision.
          </p>

          <div className='flex justify-center gap-3'>
            <span className='flex gap-2'>
                <FeatureCheckmarkNoBg/>
                No credit card required
            </span>
            <span className='flex gap-2'>
                <FeatureCheckmarkNoBg/>
                Start in seconds
            </span>
            <span className='flex gap-2'>
                <FeatureCheckmarkNoBg/>
                Full access
            </span>
          </div>

          <div className="mt-10">
            <PricingToggle
              billing={billing}
              setBilling={setBilling}
            />
          </div>

          <PricingGrid plans={plans} />
          <PlanFeatures />
        </div>
      </section>
    </PageShell>
  )
}

export default Pricing